export const flagIconStyle = {
	borderRadius: 2,
	minWidth: 16
};
